import Big from 'big.js'

import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import type {AccountInformation} from '@/auth/model'
import {getDiscount} from '@/services/rewardService'

export function getDiscountQueryKey({
  price,
  account,
}: {
  price: Big
  account: AccountInformation | undefined
}) {
  return ['discount', account?.id, price] as const
}

export function getDiscountQueryOptions({
  price,
  account,
}: {
  price: Big
  account: AccountInformation | undefined
}) {
  return queryOptions({
    queryKey: getDiscountQueryKey({price, account}),
    queryFn: async () => getDiscount({price, accountId: account?.id}),
    placeholderData: prev => prev,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}

export default function useDiscountAmount(price: Big) {
  const account = useAccountInformationValue()

  return useQuery(getDiscountQueryOptions({price, account}))
}
